export interface RuleEngineService {
    /**
     * @throws ConnectwareError | CybusRuleEngineExecutionError
     */
    transform(input: unknown, transformationExpression: string): Promise<unknown>
}
